/* Brackets
    --mountType <string::enum> | ['Surface', 'In Wall', 'Hidden']
    --length <string>
    --loadWeight <float> | pounds
    --minShelfDepth <float> | inches
    --maxShelfDepth <float | inches | ('Good for shelves of depth X" to Y"')
*/
import { loadWeight } from '@/modules/standardItems/schemas/baseHeaders'
import hardwareHeaders from '@/modules/standardItems/schemas/hardware/headers'

export default [
  ...hardwareHeaders,
  {
    text: 'Mount',
    value: 'mountType',
    sortable: true,
    sort: 'string'
  },
  {
    text: 'Length',
    value: 'length',
    sortable: true,
    sort: 'string'
  },
  {
    text: 'Min Shelf Depth (in)',
    value: 'minShelfDepth',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  },
  {
    text: 'Max Shelf Depth (in)',
    value: 'maxShelfDepth',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  },
  loadWeight()
]
